<template>
  <div class="slim-mainpanel">
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item"><a href="#">Operacional</a></li>
          <li class="breadcrumb-item"><a href="#">Logística</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            Relatório de Cotações Internacionais
          </li>
        </ol>
        <h6 class="slim-pagetitle">Relatório de Cotações Internacionais</h6>
      </div>

      <div class="bd bd-1 bd-b-0">
        <div
          class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5"
        >
          <ul class="nav gap1">
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo">
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div
                    v-if="filter.date.start !== '' && filter.date.end !== ''"
                  >
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-calendar"></i> Período de Envio:
                      <span
                        class="pd-x-5 badge mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.date.start | moment("DD/MM/YYYY") }} até
                        {{ filter.date.end | moment("DD/MM/YYYY") }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span> <i class="fa fa-calendar mg-r-5"></i> Período</span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-400" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Data do Período
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione uma data inicial e final (data de envio da cotação)
                  </p>

                  <div class="form-layout form-layout-2 modify">
                    <div class="row no-gutters">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="form-control-label">
                            Data Inicial <span class="tx-danger">*</span></label
                          >
                          <date-picker
                            lang="pt-br"
                            v-model="filter.date.start"
                            name="startDate"
                            format="DD/MM/YYYY"
                            placeholder="Data Inicial"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6 mg-t--1 mg-md-t-0">
                        <div class="form-group mg-md-l--1">
                          <label class="form-control-label">
                            Data Final <span class="tx-danger">*</span></label
                          >
                          <date-picker
                            lang="pt-br"
                            v-model="filter.date.end"
                            name="endDate"
                            format="DD/MM/YYYY"
                            placeholder="Data Final"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.forwarders.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-ship tx-danger mg-r-5"></i>Forwarders:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="f in filter.forwarders"
                        :key="f.id"
                      >
                        {{ f.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                      ><i class="fa fa-ship tx-medium mg-r-5"></i> Forwarder
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Forwarder
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais forwarders ({{
                      optionsForwarders.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Forwarders </label>
                          <v-select
                            v-model="filter.forwarders"
                            label="name"
                            :options="optionsForwarders"
                            name="forwarders"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.customers.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-building tx-danger mg-r-5"></i>Clientes:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.customers"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                      ><i class="fa fa-building tx-medium mg-r-5"></i> Clientes
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Clientes
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais clientes ({{
                      listOfCustomers.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Clientes </label>
                          <v-select
                            v-model="filter.customers"
                            label="name"
                            :options="listOfCustomers"
                            name="customers"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.statuses.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-envelope tx-danger mg-r-5"></i>Status do e-mail:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="s in filter.statuses"
                        :key="s.value"
                      >
                        {{ s.label }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                      ><i class="fa fa-envelope tx-medium mg-r-5"></i> Status do e-mail
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Status do e-mail
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais status
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Status do e-mail </label>
                          <v-select
                            v-model="filter.statuses"
                            label="label"
                            :options="listOfQuotationStatuses"
                            name="statuses"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.label }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.approved">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-check tx-info mg-r-5"></i>Aprovado:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.approved.name }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                      ><i class="fa fa-check tx-medium mg-r-5"></i> Aprovado</span
                    >
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Aprovado
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione para filtrar cotações aprovadas ou não aprovadas
                  </p>
                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Aprovado </label>
                          <v-select
                            v-model="filter.approved"
                            label="name"
                            :options="listOfApproved"
                            name="approved"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
            <li class="mg-l-10">
              <div class="btn-group d-flex fgap1" role="group" aria-label="Ações">
                <button
                  type="button"
                  class="btn btn-outline-secondary pd-x-20"
                  @click.prevent="clearFilters"
                >
                  <i class="icon ion-funnel tx-bold mg-r-5"></i> LIMPAR
                </button>
                <button
                  type="button"
                  class="btn btn-primary pd-x-20"
                  @click.prevent="generate"
                >
                  <i class="fa fa-file-code-o mg-r-5"></i> GERAR
                </button>
                <download-excel
                  :data="listOfResults"
                  :fields="excelColumns"
                  class="btn btn-success pd-x-20 mg-l-10"
                  v-if="listOfResults.length > 0"
                  :name="`relatorio-cotacoes-internacionais.xls`"
                >
                  <i class="far fa-file-excel mg-r-5"></i>
                  EXCEL
                </download-excel>
              </div>
            </li>
          </ul>
        </div>

        <div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
          <div class="pd-10 mg-10">
            <label class="section-title mg-t-10 tx-16">
              Resultado da Consulta
            </label>
            <p class="mg-b-0">
              Foram encontradas {{ count }} cotações de acordo com o filtro acima.
            </p>
            <hr />
            <div class="table-responsive">
              <table class="table table-striped mg-b-0 tx-gray-800 tx-12">
                <thead>
                  <tr>
					<th class="tx-center">Data de envio da cotação</th>
					<th class="tx-center">Código da cotação</th>
                    <th class="tx-center">Destinatário</th>
					<th class="tx-center">Status do e-mail</th>
                    <th class="tx-center">Data de visualização pelo Agente</th>
                    <th class="tx-center">Forwarder</th>
                    <th class="tx-center">Cliente</th>
                    <th class="tx-center">Referência do Processo</th>
                    <th class="tx-center">Tipo de Processo</th>
                    <th class="tx-center">Origem</th>
                    <th class="tx-center">Destino</th>
                    <th class="tx-center">Modal</th>
                    <th class="tx-center">Tipo de Embarque</th>
                    <th class="tx-center">Valores em Dólar</th>
                    <th class="tx-center">Valores em Euro</th>
                    <th class="tx-center">Valores em Reais</th>
                    <th class="tx-center">Valores em Outra Moeda</th>
                    <th class="tx-center">Valor total da cotação (R$)</th>
                    <th class="tx-center">Aprovado</th>
                  </tr>
                </thead>
                <tbody
                  v-if="listOfResults != null && listOfResults.length > 0"
                >
                  <tr
                    v-for="result in listOfResults"
                    :key="result.id"
                  >
				  	<td class="tx-center">
                      {{ result.send_date | moment("DD/MM/YYYY HH:mm:ss") }}
                    </td>
                    <td class="tx-center">{{ result.id }}</td>
                    <td class="tx-center">{{ result.person }}</td>
					<td class="tx-center">{{ result.status }}</td>
                    <td class="tx-center">
                      {{ result.preview_date | moment("DD/MM/YYYY HH:mm:ss") }}
                    </td>
                    <td class="tx-center">{{ result.companies_name }}</td>
                    <td class="tx-center">{{ result.customer_name ?? 'N/I' }}</td>
                    <td class="tx-center">
                      <a
                        v-if="result.identification"
                        href="#"
                        @click.prevent="findProcessByIdentificationSearch(result.identification)"
                      >
                        {{ getIdentification(result) }}
                      </a>
                      <span v-else>N/I</span>
                    </td>
                    <td class="tx-center">{{ result.type_of_process | typeOfProcess }}</td>
                    <td class="tx-center">{{ result.places_name ?? result.place_of_loading}}</td>
                    <td class="tx-center">{{ result.description ?? 'N/I' }}</td>
                    <td class="tx-center">{{ wayOfTransport(result.way_of_transport) }}</td>
                    <td class="tx-center">{{ formatTypeOfBoarding(result) }}</td>
                    <td class="tx-center">
                      {{ result.total_usd | numeralFormat("0,0.00") }}
                    </td>
                    <td class="tx-center">
                      {{ result.total_eur | numeralFormat("0,0.00") }}
                    </td>
                    <td class="tx-center">
                      {{ result.total_reais | numeralFormat("0,0.00") }}
                    </td>
                    <td class="tx-center">
                      {{ result.total_others | numeralFormat("0,0.00") }}
                    </td>
                    <td class="tx-center">
                      {{ result.total | numeralFormat("0,0.00") }}
                    </td>
                    <td class="tx-center">{{ formatApproved(result.approved) }}</td>
                  </tr>
                </tbody>
				<tbody v-else>
					<tr>
						<td class="valign-middle tx-center tx-uppercase tx-bold pd-5" colspan="19">
							Nenhum resultado foi encontrado!
						</td>
					</tr>
				</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import JsonExcel from "vue-json-excel";
import _ from "lodash";
import moment from "moment";
import { mapState } from "vuex";
import * as constants from "@/consts.js";
import ProcessService from "@/services/ProcessService.js";
import { formatTypeOfBoarding as formatTypeOfBoardingValue } from "@/utils/formatTypeOfBoarding.js";
import config from "@/config.js";

function defaultFilter() {
  return {
    forwarders: [],
    customers: [],
    statuses: [],
    approved: null,
    date: {
      start: moment().startOf("month").toDate(),
      end: moment().toDate(),
    },
  };
}

export default {
  name: "OperationalInternationalQuotations",
  components: {
    DatePicker,
    "download-excel": JsonExcel,
  },
  data() {
    return {
      filter: defaultFilter(),
      listOfResults: [],
      listOfCustomers: [],
	  optionsForwarders: [],
      count: 0,
      listOfQuotationStatuses: [
        { value: "ENVIADO", label: "Email Enviado" },
        { value: "VISUALIZADO", label: "Email Visualizado" },
        { value: "COTADO", label: "Cotação Preenchida" },
      ],
      listOfApproved: [
        { id: true, name: "Aprovado" },
        { id: false, name: "Não aprovado" },
      ],
	  listOfWayOfTransport: [
		{ key: "MARITIMA", value: "Marítimo" },
		{ key: "FLUVIAL", value: "Fluvial" },
		{ key: "LACUSTRE", value: "Lacustre" },
		{ key: "AEREA", value: "Aéreo" },
		{ key: "POSTAL", value: "Postal" },
		{ key: "FERROVIARIA", value: "Ferroviário" },
		{ key: "RODOVIARIA", value: "Rodoviário" },
	  ],
      excelColumns: {
		"Data de envio da cotação": {
          field: "send_date",
          callback: (value) =>
            value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "",
        },
        "Código da cotação": "id",
        Destinatário: "person",
        "Status do e-mail": "status",
		"Data de visualização pelo Agente": {
          field: "preview_date",
          callback: (value) =>
            value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "",
        },
        Forwarder: "companies_name",
        Cliente: "customer_name",
        "Referência do Processo / PRI": {
          field: "id",
          callback: (value) => {
            const row = this.listOfResults.find((r) => r.id === value);
            return row ? this.getIdentification(row) : "N/I";
          },
        },
        "Tipo de Processo": {
          field: "type_of_process",
          callback: (value) => {
            const key = (value || "").toUpperCase();
            return (
              constants.LIST_TYPE_OF_PROCESS.find((option) => option.key === key)
                ?.value ?? "-"
            );
          },
        },
        "Origem (legado)": "place_of_loading",
        Origem: "places_name",
        Destino: "description",
        Modal: {
          field: "way_of_transport",
          callback: (value) => this.wayOfTransport(value),
        },
        "Tipo de Embarque": {
          field: "id",
          callback: (value) => {
            const row = this.listOfResults.find((r) => r.id === value);
            return row ? this.formatTypeOfBoarding(row) : "Não informado";
          },
        },
        "Valores em Dólar": {
          field: "total_usd",
          callback: (value) =>
            Number(value || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
        },
        "Valores em Euro": {
          field: "total_eur",
          callback: (value) =>
            Number(value || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
        },
        "Valores em Reais": {
          field: "total_reais",
          callback: (value) =>
            Number(value || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
        },
        "Valores em Outra Moeda": {
          field: "total_others",
          callback: (value) =>
            Number(value || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
        },
        "Valor total da cotação": {
          field: "total",
          callback: (value) =>
            Number(value || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
        },
        Aprovado: {
          field: "approved",
          callback: (value) => (value ? "Sim" : "Não"),
        },
      },
    };
  },
  mounted() {
    this.getForwarders();
    this.getCustomers();
  },
  filters: {
    typeOfProcess(value) {
      const key = (value || "").toUpperCase();
      return (
        constants.LIST_TYPE_OF_PROCESS.find((option) => option.key === key)
          ?.value ?? "-"
      );
    },
  },
  methods: {
    clearFilters() {
      this.filter = defaultFilter();
    },
    formatApproved(value) {
      return value ? "Sim" : "Não";
    },
	wayOfTransport(value) {
      const key = (value || "").toUpperCase();
      return (
        this.listOfWayOfTransport.find((option) => option.key === key)
          ?.value ?? "N/I"
      );
    },
    formatTypeOfBoarding(row) {
      if (!row) {
        return "Não informado";
      }

      return formatTypeOfBoardingValue(row.way_of_transport, row.type_of_boarding);
    },
    getIdentification(row) {
      if (!row || row.identification == null || row.identification === "") {
        return "N/I";
      }

      return ProcessService.getTypeOfProcessReference({
        identification: row.identification,
        typeOfProcess: row.type_of_process || row.typeOfProcess,
      });
    },
    findProcessByIdentificationSearch(processReference) {
      try {
        if (!processReference) {
          Swal.fire(
            "Processo de Importação",
            "A referência não pode ser nula ou vazia",
            "error"
          );
          return;
        }
        const processReferenceNumbersOnly = processReference
          .toString()
          .replace(/\D/g, "");
        const route = this.$router.resolve(
          `/operational/imp/desk?showProcess=true&identification=${processReferenceNumbersOnly}`
        );
        window.open(route.href, "_blank");
      } catch (error) {
        Swal.fire("Processo de Importação", error.response, "error");
      }
    },
    keepOpen(event) {
      event.preventDefault();
      if (
        event.target &&
        (event.target.tagName === "A" || event.target.tagName === "UL")
      ) {
        const dropdowns = document.querySelectorAll(".dropdown-menu");
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove("show");
        });
      }
    },
    async getCustomers() {
      try {
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
        );
        this.listOfCustomers = response.data._embedded.companies;
      } catch (error) {
        console.error(error);
      }
    },
    async getForwarders() {
		this.$store.commit("setLoading", {
			show: true,
			label: "Carregando forwarders...",
			description: "Aguarde enquanto os forwarders estão sendo carregados...",
		});
		try {
			const response = await Axios.get(
				config.env.API_DEFAULT.host +
				"/companies/search/findAllByIsForwarderAndNameContainingIgnoreCase?isForwarder=true&name="
			);
			this.optionsForwarders = response.data._embedded.companies;
		} catch (error) {
			console.error(error);
		} finally {
			this.$store.commit("setLoading", {
				show: false,
			});
		}
    },
    generate() {
      const { filter } = this;

      if (filter.date.start === "" || filter.date.end === "") {
        Swal.fire(
          "Relatório de Cotações Internacionais",
          "Você precisa selecionar um período para conseguir gerar o relatório.",
          "error"
        );
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: "Relatório de Cotações Internacionais",
        description: "Aguarde enquanto o relatório está sendo gerado...",
      });

      const startDate = `${this.$moment(filter.date.start).format(
        "Y-MM-DDT"
      )}00:00:01`;
      const endDate = `${this.$moment(filter.date.end).format(
        "Y-MM-DDT"
      )}23:59:59`;

      let params = `from=${startDate}&to=${endDate}`;

      if (filter.forwarders.length > 0) {
        const forwarders = [];
        filter.forwarders.forEach((f) => {
          forwarders.push(f.id);
        });
        params += `&forwardersIds=${forwarders.join()}`;
      }

      if (filter.customers.length > 0) {
        const customers = [];
        filter.customers.forEach((c) => {
          customers.push(c.id);
        });
        params += `&customersIds=${customers.join()}`;
      }

      if (filter.statuses.length > 0) {
        const status = [];
        filter.statuses.forEach((s) => {
          status.push(s.value);
        });
        params += `&status=${status.join()}`;
      }

      if (filter.approved != null) {
        params += `&approved=${filter.approved.id}`;
      }

      Axios.get(
        `${config.env.API_DEFAULT.host}/freightQuotation/report/international?${params}`
      )
        .then((response) => {
          this.$store.commit("setLoading", { show: false });

          if (response.data.code === "SUCCESS") {
            this.listOfResults = response.data.data.list || [];
            this.count = response.data.data.count || 0;
            Swal.fire(
              "Relatório de Cotações Internacionais",
              response.data.message,
              "success"
            );
          } else {
            Swal.fire(
              "Relatório de Cotações Internacionais",
              response.data.message,
              "error"
            );
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", { show: false });
          Swal.fire(
            "Relatório de Cotações Internacionais",
            "Não foi possível gerar o relatório.",
            "error"
          );
        });
    },
  },
};
</script>
